export enum Role {
  None = 'None',
  Administrator = 'Administrator',
  User = 'User',
  ASM = 'ASM',
  External = 'External',
}
